import Ship from "@/model/Ship"
import ParametricTableService from "../ParametricTableService"
import utils from "@/utils/configuration/config.js"
import NeobuqFuelEUData from "@/model/Neobuq/NeobuqFuelEUData"
import FuelConsum from "@/model/FuelConsum";

class FuelEUService{

    private static instance: FuelEUService;

    private constructor() {}

    public static getInstance(): FuelEUService {
        if (!FuelEUService.instance) {
            FuelEUService.instance = new FuelEUService();
        }

        return FuelEUService.instance;
    }

    public calc_fuelEU_values(data: NeobuqFuelEUData, ship: Ship, optionGWP: string){

        let GWPValues = {}
        //console.log("data")
        //console.log(data)

        //obtenemos los valores de GWP a usar
        const parametricTables = ParametricTableService.getInstance().getParametricTable(
            utils.config.firebaseConfig.parametricVersion
        )

        if(optionGWP == "RED"){
            GWPValues = parametricTables["GWPvaluesN1"][0]
        }else if(optionGWP == "IPCC"){
            GWPValues = parametricTables["GWPvaluesN2"][0]
        }

        //CALCULAMOS EL GHG TARGET
        const ghg_intensity_index_2020 = parametricTables["2020GHGIntensityIndex"]
        let ghg_target = 0
        const year = parseInt(data.year)

        if(year >= 2025 && year < 2030){
            ghg_target = ghg_intensity_index_2020 * 0.98
        }else if(year >= 2030 && year < 2035){
            ghg_target = ghg_intensity_index_2020 * 0.94
        }else if(year >= 2035 && year < 2040){
            ghg_target = ghg_intensity_index_2020 * 0.855
        }else if(year >= 2040 && year < 2045){
            ghg_target = ghg_intensity_index_2020 * 0.69
        }else if(year >= 2045 && year < 2050){
            ghg_target = ghg_intensity_index_2020 * 0.38
        }else if(year >= 2050){
            ghg_target = ghg_intensity_index_2020 * 0.2
        }

        ghg_target = Number(ghg_target.toFixed(2))

        //CALCULAMOS EL GHG INTENSITY
        //calculamos fwind
       // const fwind = Number((data.windPower / data.propulsionPower).toFixed(2))
        let fwind = 0
        if(data.windPower == 0 &&  data.propulsionPower == 0){
            fwind = 1
        }else{
            if((data.windPower / data.propulsionPower) == 0.05){
                fwind = 0.99
            }else if((data.windPower / data.propulsionPower) == 0.1){
                fwind = 0.97
            }else if((data.windPower / data.propulsionPower) >= 0.15){
                fwind = 0.95
            }else{
                fwind = 1
            }
        }
        
        const WellToTank = Number((this.calc_wellToTank(data, ship)).toFixed(2))
        const TankToWake = Number((this.calc_tankToWake(data, ship, GWPValues)).toFixed(2))

        const ghg_intensity = Number((fwind * (WellToTank + TankToWake)).toFixed(2))

        //CALCULAMOS EL BALANCE DE CUMPLIMIENTO
        let complianceBalance = 0
        let fuelEUPenalty = 0
        let complianceSurplus = "0"
        let complianceDeficit = "0"
        if(year == 2023 || year == 2024){
            complianceBalance = 0
            fuelEUPenalty = 0
            complianceSurplus = "0"
            complianceDeficit = "0"
        }else{
            let termino = 0
            for(let i=0; i < ship.fuelConsumption.length; i++){

                let mia = 0
                //vemos si el barco es de clase hielo, para ver si usamos Mia o Mi
                if(ship.iceClassType.code == "NONE"){
                    mia = ship.fuelConsumption[i].consumption
                }else{
                    //es de clase HIELO de algún tipo, calculamos Mia  
                    mia = this.calc_mia(data, ship.fuelConsumption[i], ship)
                }

                //console.log("Termino de " + ship.fuelConsumption[i].fuel.name + ": " + (mia*1000000 * ship.fuelConsumption[i].fuel.lcv))
                termino = termino + (mia*1000000 * ship.fuelConsumption[i].fuel.lcv)
            }

            termino = termino + data.OPS
            //console.log("Termino total: " + termino)
            
            //console.log("(ghg_target - ghg_intensity): " + (ghg_target - ghg_intensity))
    
            complianceBalance = Number(((ghg_target - ghg_intensity) * termino).toFixed(2))
            //console.log("complianceBalance: " + complianceBalance)
    
            //CALCULAMOS LA SANCIÓN FUELEU y los COMPLIANCE SURPLUS Y DEFICIT
            if(complianceBalance >= 0){
                //si es el Compliance Balance es positivo, no pagamos
                fuelEUPenalty = 0
                complianceSurplus = ((complianceBalance / 1000000).toFixed(2)).toString()
                complianceDeficit = "NO"
            }else{
                //si es negativo, sí pagamos
                fuelEUPenalty = Number(((Math.abs(complianceBalance) / (ghg_intensity * 41000)) * 2400).toFixed(2))
                complianceSurplus = "NO"
                complianceDeficit = ((complianceBalance / 1000000).toFixed(2)).toString()
            }

            //console.log("fuelEUPenalty: " + fuelEUPenalty)
            //console.log("complianceSurplus: " + complianceSurplus)
            //console.log("complianceDeficit: " + complianceDeficit)
    
        }
        //devolvemos los valores 
        const res_data = {
            year: data.year, 
            anualDistanceOnIce : data.anualDistanceOnIce, 
            OPS: data.OPS, 
            windPower: data.windPower,
            propulsionPower: data.propulsionPower,
            arrayAuxFuelIce : data.arrayAuxFuelIce,
            anualAdjustedConsumption: 0,
            wellToTank : WellToTank,
            tankToWake: TankToWake,
            ghgTarget : ghg_target,
            ghgIntensity : ghg_intensity,
            complianceBalance : complianceBalance,
            fuelEUPenalty: fuelEUPenalty,
            complianceSurplus : complianceSurplus,
            complianceDeficit : complianceDeficit
        }

        //si ya hay del mismo año, NO AÑADIR, SOBREESCRIBIR
        //ship.dataForFuelEU.push(res_data)
        //ship.dataForFuelEU.splice(index, 0, res_data)

        return res_data
    }

    private calc_tankToWake(data: NeobuqFuelEUData, ship: Ship, GWPValues : {[key: string]: number}){
        
        let numerador = 0
        let denominador = 0

        //NUMERADOR
        for(let i=0; i< ship.fuelConsumption.length; i++){

            //LA PARTE DEL MIA, CREAR OTRA FUNCIÓN QUE HAGA UN ARRAY CON LOS VALORES, LO REPETIMOS EN 4 OCASIONES (NO ES EFICIENTE)
            let mia = 0
            //vemos si el barco es de clase hielo, para ver si usamos Mia o Mi
            if(ship.iceClassType.code == "NONE"){
                mia = ship.fuelConsumption[i].consumption
            }else{
                //es de clase HIELO de algún tipo, calculamos Mia  
                mia = this.calc_mia(data, ship.fuelConsumption[i], ship)
            }

            let cslip = 0
            if(ship.shipType.name === "LNG Carrier"){

                if(ship.dataForFuelEU.motorLNGOPtion === "LNG Otto (DF medium speed)"){
                    cslip = 3.1
                }else if(ship.dataForFuelEU.motorLNGOPtion === "LNG Otto (DF slow speed)"){
                    cslip = 1.7
                }else if(ship.dataForFuelEU.motorLNGOPtion === "LNG Diesel (DF slow speed)"){
                    cslip = 0.2
                }else if(ship.dataForFuelEU.motorLNGOPtion === "Motores de inyección chispa"){
                    cslip = 2.6
                }

            }else{
                cslip = 0
            }

            const fuel_cfs = ship.fuelConsumption[i].fuel.cfs
            const co2eqTtW = fuel_cfs[0]["CO2"] * GWPValues["CO2"] + fuel_cfs[0]["CH4"] * GWPValues["CH4"] + fuel_cfs[0]["N2O"] * GWPValues["N2O"] 
            const co2eqTtWslip = 0 * GWPValues["CO2"] + 1 * GWPValues["CH4"] + 0 * GWPValues["N2O"] 

            const aux1 = (1 - (1/100)*cslip) * co2eqTtW
            const aux2 = (1/100) * cslip * co2eqTtWslip
            const termino = mia * (aux1 + aux2)

            numerador = numerador + termino
        }

        //DENOMINADOR
        for(let i=0; i< ship.fuelConsumption.length; i++){

            let mia = 0
            //vemos si el barco es de clase hielo, para ver si usamos Mia o Mi
            if(ship.iceClassType.code == "NONE"){
                mia = ship.fuelConsumption[i].consumption
            }else{
                //es de clase HIELO de algún tipo, calculamos Mia  
                mia = this.calc_mia(data, ship.fuelConsumption[i], ship)
            }

            let rwd = ship.fuelConsumption[i].fuel.rwd

            if(data.year < "2025" || data.year > "2033"){
                rwd = 1
            }

            denominador = denominador + (mia * ship.fuelConsumption[i].fuel.lcv * rwd)
        }

        const var_Ek = data.OPS
        denominador = denominador + var_Ek

        const res = numerador/denominador
        
        return res
    }

    private calc_wellToTank(data: NeobuqFuelEUData, ship: Ship){

        let numerador = 0
        let denominador = 0

        for(let i=0; i < ship.fuelConsumption.length; i++){

            let mia = 0
            //vemos si el barco es de clase hielo, para ver si usamos Mia o Mi
            if(ship.iceClassType.code == "NONE"){
                mia = ship.fuelConsumption[i].consumption
            }else{
                //es de clase HIELO de algún tipo, calculamos Mia  
                mia = this.calc_mia(data, ship.fuelConsumption[i], ship)
            }

            numerador = numerador + (mia * ship.fuelConsumption[i].fuel.co2eqWtT * ship.fuelConsumption[i].fuel.lcv)
        }
        const var_Ek = data.OPS
        const co2eqelectricity = 0

        numerador = numerador + (var_Ek + co2eqelectricity)

        //PASAMOS AL DENOMINADOR
        for(let i=0; i< ship.fuelConsumption.length; i++){

            let mia = 0
            //vemos si el barco es de clase hielo, para ver si usamos Mia o Mi
            if(ship.iceClassType.code == "NONE"){
                mia = ship.fuelConsumption[i].consumption
            }else{
                //es de clase HIELO de algún tipo, calculamos Mia  
                mia = this.calc_mia(data, ship.fuelConsumption[i], ship)
            }

            let rwd = ship.fuelConsumption[i].fuel.rwd

            if(data.year < "2025" || data.year > "2033"){
                rwd = 1
            }

            denominador = denominador + (mia * ship.fuelConsumption[i].fuel.lcv * rwd)

        }

        denominador = denominador + var_Ek

        const res = numerador/denominador
        
        return res
    }

    private calc_mia(data: NeobuqFuelEUData, fuel: FuelConsum, ship: Ship){

        //fuel sería el combustible específico que estamos tratando
        let mia = 0

        if(fuel.consumption == 0){
            mia = 0
        }else{
            //1. e_voyages_total
            let e_voyages_total = 0
            for(let i=0; i<ship.fuelConsumption.length; i++){

                e_voyages_total = e_voyages_total + (ship.fuelConsumption[i].consumption * ship.fuelConsumption[i].fuel.lcv)
            }

            //2. e_voyages_ice_conditions
            let e_voyages_ice_conditions = 0
            for(let i=0; i<data.arrayAuxFuelIce.length; i++){

                e_voyages_ice_conditions = e_voyages_ice_conditions + (data.arrayAuxFuelIce[i].anualIceConsumption * ship.fuelConsumption[i].fuel.lcv)
            }

            //3. e_voyages_open_water
            const e_voyages_open_water = e_voyages_total - e_voyages_ice_conditions
            //4. e_voyages_ice_conditions_adjusted
            const e_voyages_ice_conditions_adjusted = data.anualDistanceOnIce * (e_voyages_open_water / (ship.totalDistance - data.anualDistanceOnIce))

            //5. e_additional_ice_conditions
            let e_additional_ice_conditions = 0
            const aux1 = 1.3 * e_voyages_open_water
            const aux2 = e_voyages_ice_conditions - e_voyages_ice_conditions_adjusted

            if(aux1 < aux2){
                e_additional_ice_conditions = aux1
            }else{
                e_additional_ice_conditions = aux2
            }

            //6. e_additional_ice_class
            let e_additional_ice_class = 0

            if(ship.iceClassType.code == "IA Super" || ship.iceClassType.code == "IA"){
                e_additional_ice_class = 0.05 * (e_voyages_total - e_additional_ice_conditions)
            }else{
                e_additional_ice_class = 0
            }

            //7. e_additional_ice
            const e_additional_ice = e_additional_ice_class + e_additional_ice_conditions

            //8. Cálculo de Mia
            let porcentaje = 0

            //tenemos que coger el porcentaje del combustible que estamos tratando actualmente
            for(let i=0; i < data.arrayAuxFuelIce.length; i++){

                if(data.arrayAuxFuelIce[i].name == fuel.fuel.name){
                    porcentaje = data.arrayAuxFuelIce[i].additionalEnergyPercentage
                }
            }

            if(e_additional_ice > (fuel.consumption * porcentaje)){
                mia = fuel.consumption * fuel.fuel.lcv
            }else{
                mia = fuel.consumption - (( e_additional_ice / fuel.fuel.lcv)* porcentaje)
            }
        }

        return mia
    }

}

export default FuelEUService;